import React, { useEffect, useState } from 'react';
import HospitalView from './HospitalView';

const TeamAggrete = (props) => {
  const {
    allAggregateData,
    setPrimaryLabels,
    setRevisionLabels,
  } = props;

  const [caseTypes, setCaseTypes] = useState([]);
  // const [caseTypeFlag, setCaseTypeFlag] = useState('all');

  useEffect(() => {
    // Generate new case types
    const newCaseTypes = allAggregateData.map((item, index) => ({
      type: 'all',
      key: Number(index) + 1
    }));

    setCaseTypes(newCaseTypes);
  }, []);

  const getActiveBadge = (type, index) => {
    const flagName = caseTypes.filter((item) => item.type === type && item.key === index);

    // Ensure at least one match exists before accessing type
    return flagName.length > 0 ? flagName[0].type : null;
  };

  const setActiveBadge = (type, index) => {
    const cloneData = structuredClone(caseTypes);
    const targetIndex = cloneData.findIndex((item) => item.key === index);

    // replace the object with a new one.
    cloneData[targetIndex].type = type;

    setCaseTypes(cloneData);
    // setCaseTypeFlag(type);
    // Ensure at least one match exists before accessing type
    return true;
  };

  return (
    <>
      {
        allAggregateData.map((item, index) => (
          <div
            style={{
              width: '100%'
            }}
            key={index}
          >
            <div
              className="row gx-2 cursor-pointer mb-1 collapsed"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse${index + 1}`}
              style={{
                backgroundColor: '#0E120F',
                fontSize: 15,
                padding: '0px',
                marginBottom: 0,
                zIndex: 999,
              }}
            >
              <div className="col bg-shipment-label">
                <h4
                  className="bg-shipment-label"
                  style={{
                    backgroundColor: '#0E120F',
                    fontSize: 15,
                    padding: '8px',
                    marginBottom: 0,
                    zIndex: 999,
                  }}
                >
                  {item.teamName}
                </h4>
              </div>

              <div
                className={`col-auto bg-shipment-label btn-collapse ${(index + 1) === allAggregateData.length ? '' : 'collapsed'}`}
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index + 1}`}
                aria-expanded={(index + 1) === allAggregateData.length ? 'true' : 'false'}
              >
                <i className="fas fa-chevron-down" style={{ color: '#eda340', padding: '8px', }} />
              </div>
            </div>

            <div className={`row gx-2 mb-1 collapse ${(index + 1) === allAggregateData.length ? 'show' : ''}`} id={`collapse${index + 1}`}>
              <div
                className="col"
                style={{
                  marginBottom: 2,
                  // backgroundColor: '#424242',
                  position: 'relative',
                  padding: 10
                }}
              >
                {
                  item.totals.length > 0
                    ? (
                      <table className="table table-noborder plan-table">
                        <thead>
                          <tr>
                            <th className="text-uppercase">Type</th>
                            <th className="text-center text-uppercase">Cases</th>
                            <th className="text-center text-uppercase">Primary</th>
                            <th className="text-center text-uppercase">Revision</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            item.totals.map((filteredSet, k) => (
                              <tr className="cursor-pointer" key={k} onClick={() => setActiveBadge(filteredSet.Type, (index + 1))}>
                                <td>
                                  <span
                                    className={`cursor-pointer ${getActiveBadge(filteredSet.Type, (index + 1)) === filteredSet.Type ? 'badge badge-warning' : 'theme-color'}`}
                                  >
                                    {filteredSet.Type}
                                  </span>
                                </td>
                                <td className="text-center">{filteredSet.Cases}</td>
                                <td className="text-center">{(filteredSet.PrimaryCount > 0) ? filteredSet.PrimaryCount : ''}
                                  {`${setPrimaryLabels(filteredSet)}`}
                                </td>
                                <td className="text-center">{(filteredSet.RevisionCount > 0) ? filteredSet.RevisionCount : ''}
                                  {`${setRevisionLabels(filteredSet)}`}
                                </td>
                              </tr>
                            ))
                          }
                          <tr className="cursor-pointer" onClick={() => setActiveBadge('all', (index + 1))}>
                            <td>
                              <span
                                className={`cursor-pointer ${getActiveBadge('all', (index + 1)) === 'all' ? 'badge badge-warning' : 'theme-color'}`}
                              >
                                All
                              </span>
                            </td>
                            <td className="text-center">
                              {
                                item.totals.reduce((prev, current) => (
                                  (prev + +current.Cases) > 0 && (prev + +current.Cases)
                                ), 0)
                              }
                            </td>
                            <td className="text-center">
                              {
                                item.totals.reduce((prev, current) => (
                                  (prev + +current.PrimaryCount) > 0
                                  && (prev + +current.PrimaryCount)
                                ), 0)
                              }
                            </td>
                            <td className="text-center">
                              {
                                item.totals.reduce((prev, current) => (
                                  (prev + +current.RevisionCount) > 0
                                  && (prev + +current.RevisionCount)
                                ), 0)
                              }
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ) : ''
                }

                {
                  Object.keys(item.hospital_sets).length > 0 && (
                    <HospitalView
                      hospitalSets={item.hospital_sets}
                      caseType={caseTypes}
                      keyType={(index + 1)}
                    />
                  )
                }
              </div>
            </div>
          </div>
        ))
      }
    </>
  );
};

export default TeamAggrete;
